export { default } from './RefundSelectionPage';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/RefundSelectionPage/index.ts